import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[piqetCtrlKFocus]',
})
export class CtrlKFocusDirective {
  constructor(private readonly host: ElementRef<HTMLInputElement>) {}

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.host.nativeElement.focus();
      this.host.nativeElement.select?.();
    }
  }
}
